import React from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'antd'
import { COMPLEX } from 'utils/constants'
import { Button } from 'components/patterns'
import { useHelpModal } from 'components/HelpModal'
import ContextualHelp from 'components/ContextualHelp'
import EdgeTriggerHelpContent from 'components/feature/NavigatorPanes/editors/base/EdgeEditor/HelpContent'
import OperatorHelpContent from 'components/feature/NavigatorPanes/editors/base/OperatorEditor/HelpContent'
import { CollapseWrapper, HelpButtonRow } from './ConditionHelpAccordion.style'

const HelpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <circle cx={10} cy={10} r={9.5} fill="#6C18BA" stroke="#6C18BA" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.666 13.333 12.083 10 6.666 6.667v2.5H3.333v1.666h3.333v2.5z"
      clipRule="evenodd"
    />
    <circle cx={15} cy={10} r={1.667} fill="#fff" />
  </svg>
)

const ConditionHelpAccordion = ({ parentType }) => {
  const { openModal } = useHelpModal()
  const isLogicSet = parentType === COMPLEX

  const handleOpenOperatorHelp = () => {
    openModal(<OperatorHelpContent />)
  }

  const handleOpenEdgeTriggerHelp = () => {
    openModal(<EdgeTriggerHelpContent />)
  }

  return (
    <CollapseWrapper>
      <Collapse bordered={false}>
        <Collapse.Panel
          header={
            <>
              Want help understanding this condition?
              <span className="caret-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={10}
                  height={5}
                  viewBox="0 0 10 5"
                >
                  <path d="M0 0l5 5 5-5z" fill="currentColor" />
                </svg>
              </span>
            </>
          }
          key="help"
          showArrow={false}
        >
          <ContextualHelp
            icon={<HelpIcon />}
            contentMsg="CHEC uses your settings to determine how this condition behaves. Learn how they work below."
          >
            <HelpButtonRow>
              {isLogicSet && (
                <Button type="secondary" onClick={handleOpenEdgeTriggerHelp}>
                  Edge Triggers
                </Button>
              )}
              <Button type="secondary" onClick={handleOpenOperatorHelp}>
                Operators
              </Button>
            </HelpButtonRow>
          </ContextualHelp>
        </Collapse.Panel>
      </Collapse>
    </CollapseWrapper>
  )
}

ConditionHelpAccordion.propTypes = {
  parentType: PropTypes.string.isRequired,
}

export default ConditionHelpAccordion
